module.exports = __webpack_public_path__ + "static/media/signature.913e654e.png";